<template>
    <!-- begin::Header -->
	<header id="m_header" class="m-grid__item m-header " m-minimize="minimize" m-minimize-mobile="minimize" m-minimize-offset="10" m-minimize-mobile-offset="10">
		<div class="m-header__top">
			<div class="m-container m-container--fluid m-container--full-height m-page__container">
				<canvas id="viewer" height="100" width="1920" style="
				    position: absolute;
				    top: 0;
				    left: 0;
				    opacity: 1;
				    transition: opacity 1s ease-in;
				    width: 100%;
				    right: 0;
				"></canvas>
				<div class="m-stack m-stack--ver m-stack--desktop">

					<!-- begin::Brand -->
					<div class="m-stack__item m-brand m-stack__item--left">
						<div class="m-stack m-stack--ver m-stack--general m-stack--inline">
							<div class="m-stack__item m-stack__item--middle m-brand__logo">
								<a href="/" class="m-brand__logo-wrapper">
									<img alt="" src="../assets/img/logos/logo_header.jpg" class="m-brand__logo-default" />
									<img alt="" src="../assets/img/logos/logo_header.jpg" class="m-brand__logo-inverse" />
								</a>
							</div>
							<div class="m-stack__item m-stack__item--middle m-brand__tools">


								<!-- begin::Topbar Toggler-->
								<!-- <a id="m_aside_header_topbar_mobile_toggle" href="javascript:;" class="m-brand__icon m--visible-tablet-and-mobile-inline-block">
									<i class="flaticon-more"></i>
								</a> -->

								<a href="javascript:;" id="m_aside_left_offcanvas_toggle" class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
									<span></span>
								</a>

								<ul class="m-topbar__nav m-nav m-nav--inline m-brand__icon m--visible-tablet-and-mobile-inline-block">
									<user-info />
								</ul>
								
								<!-- begin::Responsive Header Menu Toggler-->
								<!-- <a id="m_aside_header_menu_mobile_toggle" href="javascript:;" class="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
									<span></span>
								</a> -->
								<!-- end::Responsive Header Menu Toggler-->

								<!--end::Topbar Toggler-->
							</div>
						</div>
					</div>
					<!-- end::Brand -->
					<div class="m-header-search"></div>
					<!-- begin::Topbar -->
					<div class="m-stack__item m-stack__item--right m-header-head" id="m_header_nav">
						<div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general">
							<div class="m-stack__item m-topbar__nav-wrapper">
								<ul class="m-topbar__nav m-nav m-nav--inline">
									<li class="m-nav__item m-topbar__notifications m-dropdown m-dropdown--large m-dropdown--arrow m-dropdown--align-center m-dropdown--mobile-full-width">
										<a href="/notify" class="m-nav__link m-dropdown__toggle" id="m_topbar_notification_icon">
											<!-- <span class="m-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger"></span> -->
											<span class="m-nav__link-icon"><span class="m-nav__link-icon-wrapper"><i class="flaticon-alarm"></i></span></span>
										</a>
									</li>
									<user-info />
								</ul>
							</div>
						</div>
					</div>

					<!-- end::Topbar -->
				</div>
			</div>
		</div>
		<div class="m-header__bottom">
			<div class="m-container m-container--fluid m-container--full-height m-page__container">
				<div class="m-stack m-stack--ver m-stack--desktop">
					<!-- <menu-component /> -->
				</div>
			</div>
		</div>
	</header>
	<!-- end::Header -->
</template>
<script>
	import Menu from "./Menu";
	import UserInfo from "./UserInfo";

    export default {
        components: {
        	'menu-component': Menu,
        	'user-info': UserInfo
        }
	}
</script>